<div data-testid="map-fetch-loader" class="map-fetch-loader">
  <span/>
</div>
